import { HttpService, ReportingService, ReportingProvider } from '@lk/api'

export const makeReportingService = (http: HttpService, baseUrl: string) =>
  new ReportingService(new ReportingProvider(http, baseUrl))
